/* WebSocket client with auto-reconnect and pub/sub */

let socket = null;
let listeners = new Set();
let reconnectTimer = null;
let pingTimer = null;
let manualClose = false;

function getWsUrl() {
  const token = localStorage.getItem("btp_token");
  if (!token) return null;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  if (!base) return null;
  let url;
  try { url = new URL(base); } catch { return null; }
  const proto = url.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${url.host}/api/ws?token=${encodeURIComponent(token)}`;
}

export function connectWS() {
  manualClose = false;
  if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) return;
  const url = getWsUrl();
  if (!url) return;
  try {
    socket = new WebSocket(url);
  } catch {
    socket = null;
    scheduleReconnect();
    return;
  }
  socket.onopen = () => {
    if (pingTimer) clearInterval(pingTimer);
    pingTimer = setInterval(() => {
      try { socket?.send("ping"); } catch { /* noop */ }
    }, 25000);
  };
  socket.onmessage = (ev) => {
    if (ev.data === "pong") return;
    try {
      const msg = JSON.parse(ev.data);
      listeners.forEach((l) => { try { l(msg); } catch { /* noop */ } });
    } catch { /* ignore non-json */ }
  };
  socket.onclose = () => {
    if (pingTimer) { clearInterval(pingTimer); pingTimer = null; }
    socket = null;
    if (!manualClose) scheduleReconnect();
  };
  socket.onerror = () => { /* close handler will reconnect */ };
}

function scheduleReconnect() {
  if (reconnectTimer) return;
  reconnectTimer = setTimeout(() => {
    reconnectTimer = null;
    connectWS();
  }, 3000);
}

export function disconnectWS() {
  manualClose = true;
  if (reconnectTimer) { clearTimeout(reconnectTimer); reconnectTimer = null; }
  if (pingTimer) { clearInterval(pingTimer); pingTimer = null; }
  if (socket) { try { socket.close(); } catch { /* noop */ } socket = null; }
  listeners.clear();
}

export function subscribeWS(handler) {
  listeners.add(handler);
  return () => listeners.delete(handler);
}
